import { Entry, BooleanDisplayMessage, BorderedBox } from "../components";
import { ProtectedImg } from "components";
import { Row, Col, TabPane } from "reactstrap";

const SignatureDisplay = ({ src, title }) =>
	src && (
		<div className="text-center mr-2">
			<ProtectedImg src={src} style={{ width: 100, aspectRatio: 1 }} />
			<small className="text-white d-block">{title}</small>
		</div>
	);

export const LessonDetail = ({ studentRecord }) => {
	return (
		<TabPane tabId={0} key={0}>
			<Row>
				<Col sm="12">
					<BorderedBox>
						<div className="row">
							{studentRecord.studentDetail?.firstName && (
								<Entry label="Student" value={studentRecord.studentDetail?.firstName + " " + studentRecord.studentDetail?.lastName} />
							)}
							<Entry label="Lesson Date" value={studentRecord.lessonDetail.date} />
							<Entry label="Start Time" value={studentRecord.lessonDetail.startTime} />
							<Entry label="End Time" value={studentRecord.lessonDetail.endTime} />
							<Entry
								label="Teacher"
								value={studentRecord.lessonDetail?.teacher?.fullName || studentRecord.studentReport?.teacher?.name}
							/>
							<Entry label="Attendance Recorded" value={<BooleanDisplayMessage check={studentRecord.studentAttendanceRecorded} />} />
							<Entry
								label="Student Report Added"
								value={<BooleanDisplayMessage check={studentRecord.studentReportAdded} />}
								mb={false}
							/>
							<div className="d-flex justify-content-end mt-2">
								<SignatureDisplay src={studentRecord.lessonDetail?.teacherSignaturePath} title="Teacher" />
								<SignatureDisplay src={studentRecord.studentSignaturePath} title="Student" />
							</div>
						</div>
					</BorderedBox>
				</Col>
			</Row>
		</TabPane>
	);
};
